<!--
 * @Date: 2023-04-21 15:19:08
 * @LastEditors: murray
 * @LastEditTime: 2023-05-25 15:32:17
 * @FilePath: \haizol-saas-console-supplier\src\components\common\ServiceAgreement.vue
 * @Description: 阅读服务协议
-->

<template>
  <div class="service-agreement">
    <el-dialog
      width="736"
      :visible.sync="show"
      @close="$emit('close')"
      :close-on-click-modal="false"
    >
      <div class="content">
        <div
          id="service-agreement-text"
          class="text fine-scroll-bar"
          :style="{ height: height + 'px' }"
          ref="serviceAgreementText"
        >
          <div class="agreements">
            <div
              class="agreement"
              v-for="(item, index) in agreements"
              :key="item.name"
            >
              <div :class="item.name + index" class="title">
                {{ item.name }}
              </div>
              <div class="html-box" v-html="item.html"></div>
            </div>
          </div>
        </div>
        <div class="btn">
          <el-button
            :disabled="!!time || btnDisabled"
            type="primary"
            @click="agreed"
            ><span v-if="time">({{ time }}s)</span> 我完整阅读并同意</el-button
          >
        </div>
        <div class="tabs">
          <div
            class="tab"
            :class="active === index ? 'active' : ''"
            v-for="(item, index) in agreements"
            :key="item.name"
            @click="toTitle(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: '请传标题',
      type: String,
    },
    // 文本容器高度
    height: {
      default: 400,
      type: Number,
    },
    // 是否强制滚动
    scrolling: {
      default: true,
      type: Boolean,
    },
    // 服务协议信息
    agreements: {
      default: () => [],
    },
    index: {},
  },
  data() {
    return {
      show: true,
      btnDisabled: true,
      active: 0,
      html: '',
      time: 5,
    }
  },
  methods: {
    agreed() {
      // 判断是否存在服务协议异常，如果异常阻止用户点击同意
      if (
        !this.agreements ||
        !this.agreements.length ||
        this.agreements.some((ele) => !ele.html)
      ) {
        return this.$message.error('系统繁忙，请稍后再试')
      }
      this.$emit('close', true)
    },

    // 点击某个协议
    toTitle(val, index) {
      // this.active = index
      document
        .querySelector(`.${val.name}${index}`)
        .scrollIntoView({ behavior: 'smooth' })
    },

    initStatus() {
      const fun = () => {
        // 开始倒计时
        let interval = setInterval(() => {
          if (!this.time) {
            clearInterval(interval)
            return (interval = null)
          }
          this.time -= 1
        }, 1000)

        // 给文本容器注册滚动事件
        try {
          this.$refs.serviceAgreementText.addEventListener(
            'scroll',
            this.scrollFun
          )
        } catch (err) {
          console.error('❌ ~ file: ServiceAgreement.vue:132 ~ fun ~ err:', err)
          document
            .querySelector('#service-agreement-text')
            .addEventListener('scroll', this.scrollFun)
        }

        // 判断有没有传index进来，如果有，直接定位到对应的index来
        if (this.index !== undefined) {
          document
            .querySelector(`.${this.agreements[this.index].name}${this.index}`)
            .scrollIntoView()
        }

        // 如果不强制滚动，直接解除按钮禁用状态
        if (!this.scrolling) return (this.btnDisabled = false)

        // 给 text 文本盒子注册滚动事件
        this.$nextTick(() => {
          setTimeout(() => {
            const text = this.$refs.serviceAgreementText
            const totalHeight = text.scrollHeight
            const visibleHeight = text.clientHeight

            // 先判断text的高度是否不超出，如果不超出则不参与滚动
            if (totalHeight <= this.height) {
              return (this.btnDisabled = false)
            }

            const scrollFun = () => {
              // 当滚动到底部时，将按钮的禁用取消掉
              if (text.scrollTop + visibleHeight + 30 >= totalHeight) {
                this.btnDisabled = false
                text.removeEventListener('scroll', scrollFun)
              }
            }
            text.addEventListener('scroll', scrollFun)
            scrollFun()
          }, 500)
        })
      }
      try {
        fun()
      } catch (err) {
        console.error(
          '❌ ~ file: ServiceAgreement.vue:153 ~ initStatus ~ err:',
          err
        )
        // 如果执行错误走到了catch，等500毫秒再执行一次
        setTimeout(() => {
          fun()
        }, 500)
      }
    },

    // 当文本容器发生滚动时
    scrollFun() {
      const currentScroll =
        document.querySelector('.fine-scroll-bar').scrollTop + 200
      const articleElements = document.querySelectorAll('.agreement')

      let currentArticleIndex = 0
      for (let i = 0; i < articleElements.length; i++) {
        if (currentScroll >= articleElements[i].offsetTop) {
          currentArticleIndex = i
        }
      }

      this.active = currentArticleIndex
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initStatus()
    })
  },

  beforeDestroy() {
    try {
      this.$refs.serviceAgreementText.removeEventListener(
        'scroll',
        this.scrollFun
      )
    } catch (err) {
      console.error(
        '❌ ~ file: ServiceAgreement.vue:200 ~ beforeDestroy ~ err:',
        err
      )
    }
  },
}
</script>

<style lang="scss" scoped>
.service-agreement {
  .content {
    .text {
      height: 400px;
      overflow-y: auto;
    }
    .tabs {
      position: absolute;
      left: 0;
      top: 32px;
      display: flex;
      flex-direction: column;
      .tab {
        writing-mode: vertical-rl; /* 纵向排列 */
        display: flex;
        flex-direction: column;
        border: 1px solid #cfd5df;
        padding: 6px 12px;
        width: 12px;
        line-height: 12px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #4f5d78;
        cursor: pointer;
        &:first-child {
          border-top-right-radius: 4px;
        }
        &:last-child {
          border-bottom-right-radius: 4px;
        }
      }
      .active {
        border-color: #066eb7;
        color: #066eb7;
      }
    }
    .html-box {
      width: 605px;
      margin: 0;
      ::v-deep .container {
        width: 605px;
      }
    }
    .agreements {
      .agreement {
        > .title {
          font-size: 20px;
          color: #16181a;
          font-weight: bold;
        }
      }
    }
  }
  ::v-deep .el-dialog {
    position: relative;
    width: 736px;
    .el-dialog__header {
      padding: 14px 0 20px 74px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #16181a;
      .el-dialog__headerbtn {
        top: 18px;
        right: 18px;

        i {
          font-weight: 14px;
          font-weight: bold;
        }
      }
    }
    .el-dialog__body {
      padding: 0 48px 0 74px;
      .btn {
        height: 100px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        button {
          width: 216px;
          height: 44px;
          font-size: 16px;
        }
        .is-disabled {
          background: #cfd5df;
          color: #ffffff;
          border-color: #cfd5df;
        }
      }
    }
  }
}
</style>
